import React from 'react';
import { Button } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import style from './index.module.scss';
import { TooltipError } from 'components/tooltips';
import clsx from 'clsx';
import { Stack } from 'components/stack';
import AddIcon from '@mui/icons-material/Add';

interface Props {
  isShowCloneTooltip: boolean;
  onClone?: () => void;
  onCreate: () => void;
  disabled: boolean;
}
export const ControlSlot: React.FC<React.PropsWithChildren<Props>> = ({
  onClone,
  onCreate,
  disabled,
  isShowCloneTooltip,
}) => {
  const { t, tp } = useTranslate();

  return (
    <Stack
      spacing={1}
      sx={{
        px: 1,
      }}
    >
      {onClone && (
        <TooltipError
          open={isShowCloneTooltip}
          title={tp('rule-clinical-drugs-copy')}
          arrow
          placement={'top'}
          classes={{
            popper: style.tooltip,
          }}
        >
          <Button
            className={clsx(style.btnCopy, isShowCloneTooltip && style.blink)}
            startIcon={<FileCopyIcon />}
            onClick={onClone}
            disabled={disabled}
          >
            {t('clone-from-previous')}
          </Button>
        </TooltipError>
      )}
      <Button
        color={'primary'}
        variant={'contained'}
        startIcon={<AddIcon />}
        disabled={disabled}
        onClick={onCreate}
      >
        {tp('add-new')}
      </Button>
    </Stack>
  );
};
